import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/pages/page404/page404.component";
 import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
 import { AuthGuard } from "./core/guard/auth.guard";
const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
   canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/common/landing-page", pathMatch: "full" },
      {
        path: "admin",
        loadChildren: () =>
          import("./admin/admin.module").then((m) => m.AdminModule),
      },
      {
        path: "account",
        loadChildren: () =>
          import("./account/account.module").then((m) => m.AccountModule),
      },

    ],
  },





  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },

  {
    path: "common",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./landing/landing.module").then(
        (m) => m.LandingModule
      ),
  },


  //***************************************************************************************************** */
  //***************************************************************************************************** */

  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
